/* eslint-disable prettier/prettier */
import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import DescriptionIcon from '@mui/icons-material/Description';
import { Box } from '@mui/material';
import { Button, Table } from 'components';
import { Form, Formik } from 'formik';
import { downloadcsv } from 'helpers/downloadcsv';
import { AuthContext } from 'hooks/useAuth';
import { PageTitle } from 'pages/Layout/PageTitle';
import { launchPrivider } from 'services';
import { providerService } from 'services';
import { useContextSelector } from 'use-context-selector';

const columns = [
  { label: 'OS' },
  { label: 'MODELO' },
  { label: 'PN' },
  { label: 'SERIAL OUT' },
  { label: 'CLIENTE OPV' },
  { label: 'NF CLIENTE' },
  { label: 'LAUDO' },
  { label: 'DT. LAUDO' },
  { label: 'DT. ENV APROVACAO' },
  { label: 'ARQUIVO LAUDO' },
  { label: 'PROSSEGUIR' },
  { label: 'DEVOLVER' },
  { label: 'NÃO AVALIADO' },
];

export const ApprovalReportFirst = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [checkboxState, setCheckboxStates] = useState({});
  const [laudoData, setLaudoData] = useState([]);
  const user = useContextSelector(AuthContext, (context) => context.user);
  const [buttonLaudo, setButtonLaudo] = useState(false);

  const handleTable = useCallback(async () => {
    try {
      const jsonObject = JSON.parse(localStorage.getItem('@Gaia:user'));
      const userRoleId = jsonObject?.role?.id;

      let data;

      if (userRoleId === 11) {
        ({ data } = await launchPrivider.getInfReportApprovalServiceFirst());
        console.log('entrou, first');
      } else {
        ({ data } = await launchPrivider.getInfReportApprovalService());
        console.log('entrou normal');
      }

      setLaudoData(data);
      const formattedData = Array.isArray(data) ? data : [];

      const initialCheckBoxStates = formattedData.reduce((acc, item) => {
        acc[item.numeroOs] = {
          OS: item.numeroOs,
          prosseguirReparo: false,
          devolverSemReparo: false,
          naoAvaliado: true,
        };
        return acc;
      }, {});

      setCheckboxStates(initialCheckBoxStates);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Erro');
    }
  }, []);

  useEffect(() => {
    handleTable();
  }, [handleTable]);

  const handleCheckboxChange = (os, field) => {
    setCheckboxStates((prevState) => ({
      ...prevState,
      [os]: {
        prosseguirReparo: field === 'prosseguirReparo',
        devolverSemReparo: field === 'devolverSemReparo',
        naoAvaliado: field === 'naoAvaliado',
      },
    }));
  };

  const handleDownloadApprovalReportFist = async () => {
    setIsLoading(true);
    toast.info('Aguardando relatório');

    const { data } = await launchPrivider.getApprovalReportFirst();
    await downloadcsv(`ingenico_aprovacao_laudo_first`, data);
    toast.success('Relatório Gerado com Sucesso!');
    try {
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveReports = async () => {
    console.log(checkboxState);
    setIsLoading(true);
    try {
      const { data } = await launchPrivider.processReportFirst({ checkboxState, user });
    } catch (erro) {
      toast.error(erro);
    } finally {
      setIsLoading(false);
      //toast.success('Enviado com sucesso!');
      window.location.reload();
    }
  };

  const hanldeGetDownloadLaudo = async (obj) => {
    console.log(obj);
    toast.info('Aguarde o Laudo ser gerado');
    try {
      const { data } = await providerService.reportGenerator(obj);
      console.log('tetetete', data);
      const file = new Blob([data], { type: 'application/pdf' });
      saveAs(file, 'laudo.pdf');
      toast.success('Laudo gerado com sucesso.');
    } catch (error) {
      toast.error('Não foi possivel gerar laudo.');
    }
  };

  return (
    <>
      <PageTitle>Aprovação de Laudo First</PageTitle>
      <Formik initialValues={{}} onSubmit={handleSaveReports}>
        <Form>
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={3}>
                <Button fullWidth onClick={handleDownloadApprovalReportFist} loading={isLoading}>
                  Exportar Relatório
                </Button>
              </Grid>
              <Grid item xs={3} md={3} lg={3}>
                <Button type='submit' fullWidth color='secondary' loading={isLoading}>
                  Salvar
                </Button>
              </Grid>
            </Grid>
          </Box>
          <Grid container spacing={2} style={{ paddingTop: '1rem' }}>
            <Grid item xs={12} lg={12} md={12}></Grid>
          </Grid>

          <Table headers={columns} disableNumeration loading={isLoading}>
            {(laudoData || []).map((item, index) => (
              <TableRow key={index}>
                {/* {console.log('item', item)} */}
                <TableCell>{item.numeroOs}</TableCell>
                <TableCell>{item.modelo}</TableCell>
                <TableCell>{item.pnModelo}</TableCell>
                <TableCell>{item.serialOut}</TableCell>
                <TableCell>{item.clienteOPV}</TableCell>
                <TableCell>{item.nfCliente}</TableCell>
                <TableCell>{item.Laudo}</TableCell>
                <TableCell>{item['Data Laudo']}</TableCell>
                <TableCell>{item.dtCadastro}</TableCell>
                <TableCell>
                  {item.length === 0 ? (
                    <></>
                  ) : (
                    <IconButton
                      color='primary'
                      disabled={buttonLaudo || item.destinoPerda === null}
                      onClick={() => hanldeGetDownloadLaudo(item)}
                    >
                      <DescriptionIcon />
                    </IconButton>
                  )}
                </TableCell>
                <TableCell>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color='primary'
                        checked={checkboxState[item.numeroOs]?.prosseguirReparo || false}
                        onChange={() => handleCheckboxChange(item.numeroOs, 'prosseguirReparo')}
                      />
                    }
                  ></FormControlLabel>
                </TableCell>
                <TableCell>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color='primary'
                        checked={checkboxState[item.numeroOs]?.devolverSemReparo || false}
                        onChange={() => handleCheckboxChange(item.numeroOs, 'devolverSemReparo')}
                      />
                    }
                  ></FormControlLabel>
                </TableCell>
                <TableCell>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color='primary'
                        checked={checkboxState[item.numeroOs]?.naoAvaliado || false}
                        onChange={() => handleCheckboxChange(item.numeroOs, 'naoAvaliado')}
                      />
                    }
                  ></FormControlLabel>
                </TableCell>
              </TableRow>
            ))}
          </Table>
        </Form>
      </Formik>
    </>
  );
};
